import { defineStore } from 'pinia';
import AssessmentMaterialService from '@/services/AssessmentMaterialService';
import { useAssessmentStore } from '@/store';
import { CreateMaterialPayload, UpdateMaterialPayload, ApiErrorResponse, MaterialInterface } from '@/types';

interface MaterialStoreStateInterface {
  materials: {
    loading: boolean;
    data: MaterialInterface[];
    total: number;
  };
  error: boolean;
  message: string;
  loading: boolean;
}

export default defineStore('MaterialStore', {
  state: (): MaterialStoreStateInterface => ({
    materials: {
      loading: false,
      data: [],
      total: 0,
    },
    error: false,
    message: '',
    loading: false,
  }),

  getters: {
    errorTitle: () => 'Material Error',
  },

  actions: {
    setMaterials() {
      const assessmentStore = useAssessmentStore();
      const materials: MaterialInterface[] = [];
      const recordForms = assessmentStore.currentAssessment.data?.assessment_record_forms || [];

      recordForms.forEach((recordForm) => {
        recordForm.assessment_materials.forEach((material) => {
          materials.push({
            ...material,
            record_form_id: recordForm.id,
            assessment_id: recordForm.assessment_id,
            record_form_title: recordForm.title,
          });
        });
      });

      materials.sort((a, b) => a.title.localeCompare(b.title));

      this.materials.data = materials;
      this.materials.total = materials.length;
    },

    async createMaterial(payload: CreateMaterialPayload) {
      this.loading = true;
      try {
        const response = await AssessmentMaterialService.createMaterial(payload.assessment_id, payload);
        await useAssessmentStore().clearCurrentAssessment();
        await useAssessmentStore().getAssessment(payload.assessment_id);
        this.loading = false;
        return response.data;
      } catch (error) {
        this.loading = false;
        throw error as ApiErrorResponse;
      }
    },

    async updateMaterial(id: number, assessmentId: number, payload: UpdateMaterialPayload) {
      this.loading = true;
      try {
        const response = await AssessmentMaterialService.updateMaterial(id, payload);
        await useAssessmentStore().clearCurrentAssessment();
        await useAssessmentStore().getAssessment(assessmentId);
        this.loading = false;
        return response.data;
      } catch (error) {
        this.loading = false;
        throw error as ApiErrorResponse;
      }
    },

    async deleteMaterial(id: number, assessmentId: number) {
      this.loading = true;
      try {
        const response = await AssessmentMaterialService.deleteMaterial(id);
        await useAssessmentStore().clearCurrentAssessment();
        await useAssessmentStore().getAssessment(assessmentId);
        this.loading = false;
        return response.data;
      } catch (error) {
        this.loading = false;
        throw error as ApiErrorResponse;
      }
    },
  },
});
